import type { CookiesPage, CookiesPageQuery } from '@edwin-group/cj-graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_COOKIES_PAGE } from '@edwin-group/cj-graphql';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<CookiesPageQuery>({
      query: QUERY_COOKIES_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.cookiesPage?.data?.attributes as CookiesPage,
    error,
  };
};
